
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/science-and-data",
      function () {
        return require("private-next-pages/science-and-data.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/science-and-data"])
      });
    }
  